import { useContext } from 'react';
import { LoadingCoordinatorContext } from 'site-modules/personalized-search/context/loading-context/loading-coordinator-context';

export function useLoadingCoordinator() {
  return useContext(LoadingCoordinatorContext);
}
